/**
 * Tenant-area route paths a page outside this area links to: `./routes.ts`
 * registers them, and a caller elsewhere derives its href from the same
 * literal (`../control/paths.ts` exists for the identical reason).
 *
 * Relative to the router's `basepath`, like every other route literal.
 */

import { interpolatePath } from '@tanstack/react-router';

export const USERS_PATH = '/t/$tenantId/usuarios';
/** The area's earlier address, kept as a redirect so a saved link still lands. */
export const LEGACY_TEAM_PATH = '/t/$tenantId/equipe';
export const DATA_PATH = '/t/$tenantId/dados';

export function usersPath(tenantId: string): string {
  return interpolatePath({ path: USERS_PATH, params: { tenantId } }).interpolatedPath;
}
